import yup from "../../../../utils/yup-extended";
import {CoverImagesItemResponse} from "../../../../react-query-hooks/products/types";
import {
  createStoreServiceBasicFormStepFormValidationSchema,
  CreateStoreServiceBasicFormStepFormValues,
} from "../../create-service/multi-step/basic-form/schema-validation";
import {GetStoreServicePortfolioImagesApiResponse} from "../../../../react-query-hooks/store/services/upload-content/types";

export const editStoreServiceBasicFormStepFormValidation = yup.object().shape({
  cover_images: yup
    .array()
    .min(1, "Add at least one image")
    .max(5, "You can only add a maximum of 5 images"),
  portfolio_images: yup.array().max(5, "You can only add a maximum of 5 images"),
});

export const editStoreServiceBasicFormStepFormValidationSchema =
  createStoreServiceBasicFormStepFormValidationSchema.concat(
    editStoreServiceBasicFormStepFormValidation
  );

export type EditStoreServiceBasicFormStepFormValuesYup = yup.InferType<
  typeof editStoreServiceBasicFormStepFormValidationSchema
>;

export type EditStoreServiceBasicFormStepFormValues =
  CreateStoreServiceBasicFormStepFormValues & {
    cover_images: CoverImagesItemResponse[];
    portfolio_images: GetStoreServicePortfolioImagesApiResponse;
  };
